import cn from 'classnames/bind';
import Head from 'next/head';
import {
  Col, Container, Row, SEO, Text, TypographyPage,
} from 'ui';
import BlogContent from 'ui/layouts/blog/BlogContent';
import CategoryPageLayout from 'ui/layouts/CategoryPageLayout';
import { dateformat } from 'utils/datetime';
import { host } from 'utils/jsonLd/utils';
import getJsonLdWebPage from 'utils/jsonLd/webPage';

import s from './Privacy.module.scss';

const cx = cn.bind(s);

const Privacy = ({ body, updatedAt }) => {
  const meta = {
    title: "Privacy policy", description: "The MyPersonality.net Privacy Policy describes how we collect, use, share, secure, and store your private information."
  }
  const jsonLd = getJsonLdWebPage({name:'Free personality test', description: meta.description, url: `${host}/privacy`})
  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          key="product-jsonld"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd)
          }}
        />
      </Head>
      <SEO title={meta.title} description={meta.description} />
      <CategoryPageLayout
        headerTitle={'Privacy policy'}
        headerNotice={`Last modified: ${dateformat.long(updatedAt)}`}
      >
        <TypographyPage as={Container} className={cx('content')}>
          <Row>
            <Col
              sm={12}
              md={{
                offset: 1,
                span: 10,
              }}
              lg={{
                offset: 2,
                span: 8,
              }}
            >
              <BlogContent body={body} />
              <Text>
              Last updated:{' '}
                {dateformat.short(updatedAt)}
              </Text>
            </Col>
          </Row>
        </TypographyPage>
      </CategoryPageLayout>
    </>
  )};

Privacy.prettyName = 'Privacy';

export async function getStaticProps() {
  const { default: PagesModel } = await import('api/models/Pages');
  const content = await PagesModel.privacyPolicy({type: process.env.NEXT_PUBLIC_LANDING_TYPE});
  return {
    props: content,
    revalidate: 60 * 30,
  };
}

export default Privacy;
